/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Livid_Capybara_LaughInputs */

const fr_quick_livid_capybara_laugh = /** @type {(inputs: Quick_Livid_Capybara_LaughInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la suppression des facteurs MFA`)
};

/**

* @param {Quick_Livid_Capybara_LaughInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const quick_livid_capybara_laugh = /** @type {((inputs?: Quick_Livid_Capybara_LaughInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Livid_Capybara_LaughInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_quick_livid_capybara_laugh(inputs)
});